export default __webpack_public_path__ + "static/media/Freja.8a363d29.jpg";